export const MALL_SETTING_LIST = "MALL_SETTING_LIST";
export const UPDATE_MALL_SETTING_STATUS = "UPDATE_MALL_SETTING_STATUS";